const TICK_INTERVAL = 1000; // tick every 1 second
const DEFAULT_DELAY = 60 * 1000; // 1 minute

const idleTimeout = () => {
  let intervalId = null;
  let delay = DEFAULT_DELAY;
  let counter = 0;
  let callback = () => {};

  const getIntervalId = () => intervalId;

  const getDelay = () => delay;

  const setDelay = (newDelay) => {
    delay = newDelay;
  };

  const setCallback = (onTimeout) => {
    callback = onTimeout;
  };

  const addListeners = () => {
    window.addEventListener('mousemove', reset);
    window.addEventListener('mousedown', reset);
    window.addEventListener('onclick', reset);
    window.addEventListener('keypress', reset);
    window.addEventListener('scroll', reset, true);
  };

  const removeListeners = () => {
    window.removeEventListener('mousemove', reset);
    window.removeEventListener('mousedown', reset);
    window.removeEventListener('onclick', reset);
    window.removeEventListener('keypress', reset);
    window.removeEventListener('scroll', reset);
  };

  // If user is idle for TIMEOUT time, navigate back to kiosk page.
  const tick = () => {
    counter += TICK_INTERVAL;
    // console.log('Idle: ', counter / 1000);

    if (counter === delay) {
      stop();
      callback();
    }
  };

  const start = () => {
    addListeners();
    intervalId = window.setInterval(tick, TICK_INTERVAL);
  };

  const stop = () => {
    removeListeners();
    window.clearInterval(intervalId);
    intervalId = null;
  };

  // Clear counter and start again from 0.
  const reset = () => {
    counter = 0;
  };

  const restart = ({ delay = DEFAULT_DELAY, onTimeout = () => {} }) => {
    stop();
    setDelay(delay);
    setCallback(onTimeout);
    reset();
    start();
  };

  return {
    start,
    stop,
    reset,
    restart,
    setCallback,
    getIntervalId,
    getDelay,
    setDelay,
  };
};

export default idleTimeout;
